<template>
<v-container style="background:#474747">

    <v-card class="mx-auto ma-10" max-width="800" outlined style="background:#474747">
        <image-carousel style="background:#474747"></image-carousel>
    </v-card>

</v-container>
</template>

<script>
import ImageCarousel from '@/components/ImageCarousel';

export default {
    name: 'HelloWorld',
    components: {
        ImageCarousel,
    },
}
</script>
